module.exports = __webpack_public_path__ + "static/media/8782.a43eade4.png";